import fuzzyHighlight from '@jetbrains/ring-ui/components/global/fuzzy-highlight'
import type {SelectItem} from '@jetbrains/ring-ui/components/select/select'

import Highlight from '../../../../../../../../common/Highlight/Highlight'

export const getBranchAutocompleteOptions = (options: SelectItem[], searchValue: string) =>
  options
    .map(({key, label = ''}) => {
      const text = `${label}`
      const matches = fuzzyHighlight(searchValue, text).matches
      const score = matches.reduce((accumulator, match) => {
        const {from, to} = match
        const diff = to - from

        return accumulator + diff
      }, 0)

      return {
        key,
        score,
        label: <Highlight string={text} matches={matches} />,
      }
    })
    .sort((a, b) => b.score - a.score)
